import styled from '@emotion/styled';
import { FormError } from 'ui/components/elements/FormError/FormError';
import { FormCheckbox } from 'ui/components/elements/FormCheckbox/FormCheckbox';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    max-height: 80vh;
    padding: 40px;
`;

const Descriptions = styled.div`
    text-align: left;
    gap: 5px;
    display: flex;
    flex-direction: column;
`;

const Desc = styled.div`
    padding: 0 4px;
    font-size: var(--font-default);
    font-weight: var(--font-bold);

    ul {
        border-radius: 4px;
        background-color: #dfecf3;
        padding: 10px;

        li {
            margin: 5px 0;
            list-style-type: none;

            &:before {
                content: '・';
            }
        }
    }
`;

const TextArea = styled.textarea`
    width: 100%;
    height: 100px;
    padding: 8px;
    border: 2px solid #a9a9a9;
    border-radius: 4px;
    font-size: var(--font-normal);

    resize: vertical;
    outline: none;
`;

const SubmitButton = styled.button`
    width: 80%;
    max-width: 200px;
    background-color: var(--primary);
    color: var(--white);
    font-size: var(--font-large);
    font-weight: var(--font-bold);
    padding: 15px;
    border-radius: 25px;
    cursor: pointer;
    margin: 10px auto 0 auto;
    border: none;
    outline: none;
`;

const ErrorMsgContainer = styled.div`
    margin-right: auto;
`;

const PremiumOfferTxt = styled.div`
    font-size: var(--font-medium);
    font-weight: var(--font-bold);
`;

interface Props {
    setValue: (value: string) => void;
    setPremiumOffer: (value: boolean) => void;
    premiumOffer: boolean;
    onClick: () => void;
    errorMsg: string;
}

/**
 * 面談リクエストモーダル
 */
export const RequestMeeting: React.FC<Props> = ({ setValue, onClick, errorMsg, premiumOffer, setPremiumOffer }) => {
    return (
        <Wrapper>
            <TextArea
                maxLength={1000}
                placeholder="メッセージ (1000文字以内)"
                onChange={(e) => setValue(e.target.value)}
            />
            <FormCheckbox
                id="premium_offer"
                checked={premiumOffer}
                onChange={() => setPremiumOffer(!premiumOffer)}
                disableBorder
            >
                <PremiumOfferTxt>プレミアムオファーを送る</PremiumOfferTxt>
            </FormCheckbox>
            <Descriptions>
                <Desc>※相手企業がマッチングを受理すると費用 ¥50,000 が発生します。</Desc>
                <Desc>
                    ※プレミアムオファー（+ ¥20,000）をすると下記の特典がつきます。
                    <ul>
                        プレミアムオファーとは？
                        <li>M&A検討企業がMAnyにログインした際にポップアップ通知が表示されます。</li>
                        <li>
                            マッチング後も、M&A検討企業の受信BOX内で2週間上位に表示され、他のDMより発見性・開封率が高くなります。
                        </li>
                    </ul>
                </Desc>
            </Descriptions>
            <ErrorMsgContainer>{errorMsg && <FormError message={errorMsg} />}</ErrorMsgContainer>
            <SubmitButton onClick={onClick}>送信する</SubmitButton>
        </Wrapper>
    );
};
